{
  "appointment-details-page": {
    "buttons": {
      "book-new-appointment": "Book new appointment"
    },
    "meta": {
      "title": "Appointment details",
      "description": "All information about the appointment"
    }
  }
}
